import React from 'react'
import s from '../css/auth.module.css'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import Loader from './Loader'

const SignIn = ({
	isPassShow,
	setPassShow,
	handleSubmit,
	handleChange,
	values,
	// errors,
	disabled,
	signInStatus,
}) => {
	return (
		<div className={s.container}>
			<div className='common__body'>
				<h3>Вход в аккаунт</h3>
				<form action='' onSubmit={e => handleSubmit(e)}>
					<div className={s.input}>
						<input
							type='email'
							placeholder='Электронная почта'
							autoComplete='off'
							onChange={e => handleChange(e)}
							defaultValue={values.login}
							name='email'
							id='email'
						/>
						{/* {errors.email && <label htmlFor='email'>{errors.email} </label>} */}
					</div>

					<div className={s.input}>
						<input
							type={isPassShow ? 'text' : 'password'}
							placeholder='Пароль'
							autoComplete='new-password'
							onChange={e => handleChange(e)}
							defaultValue={values.password}
							name='password'
							id='password'
						/>

						<div className={s.eye} onClick={setPassShow}>
							{isPassShow ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
						</div>

						{/* {errors.password && (
							<label htmlFor='password'>{errors.password} </label>
						)} */}
					</div>

					<div className={s.btn}>
						<button id='btn' disabled={disabled || signInStatus.isLoading}>
							{signInStatus.isLoading ? <Loader isButton={true} /> : 'Войти'}
						</button>

						{signInStatus.message === 'Bad credentials' && (
							<label htmlFor='btn'>Неправильный логин или пароль</label>
						)}
					</div>
				</form>

				<div className={s.links}>
					<Link to='/forgot-password'>Забыли пароль?</Link>
				</div>
			</div>
		</div>
	)
}

export default SignIn
